export default __webpack_public_path__ + "2ef2c2cfe16b7646042ef61317ceb664.jpg";